import { z } from 'zod'
import { eventSchema } from './event-vocabulary.js'

export const commandInverseSchema = z.object({
  commandId: z.string().describe('A registered server command id that reverses the mutation'),
  args: z.record(z.string(), z.unknown()).default({}),
})
export type CommandInverse = z.infer<typeof commandInverseSchema>

export const appliedActionSchema = z.object({
  commandId: z.string().describe('The plugin-owned command that ran'),
  targetEntityId: z.string().describe('The entity this action mutated'),
  inverse: commandInverseSchema
    .describe('Server-executable command that reverses this action; null when irreversible')
    .nullable(),
})
export type AppliedAction = z.infer<typeof appliedActionSchema>

export const ruleFiringBatchSchema = z.object({
  batchId: z.string().describe('Unique id for this firing'),
  ruleId: z.string().describe('The rule that fired'),
  event: eventSchema.describe('The lifecycle event that triggered the rule'),
  triggeringEntityId: z.string().describe('The entity whose change triggered the rule'),
  firedAt: z.string().describe('ISO8601 timestamp of the firing'),
  appliedActions: z.array(appliedActionSchema).describe('One entry per mutated entity, in apply order'),
})
export type RuleFiringBatch = z.infer<typeof ruleFiringBatchSchema>
